import { useMemo } from 'react';
import Dropdown from 'components/elements/Dropdown';
import RadioButtons from 'components/elements/RadioButtons';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { useRegionFilter, useStateDocFilter } from 'state/filterDocuments';
import { Region, STATE_CODE_TO_LABEL } from 'utils/constants/location';

const StateFilter = () => {
  const { stateFilter, setStateFilter } = useStateDocFilter();
  const { availableStates } = useAvailableCities();
  const { setRegionFilter } = useRegionFilter();

  const stateOptions = useMemo(
    () =>
      Object.keys(availableStates).map((key) => ({
        value: key,
        label: STATE_CODE_TO_LABEL[key] || key,
      })),
    [availableStates],
  );

  const handleStateChange = (value: string) => {
    setStateFilter(value);
    const allRegionsForState = Object.keys(availableStates[value]?.regions ?? {});
    setRegionFilter(allRegionsForState as Region[]);
  };

  const indicatorText = useMemo(() => {
    if (!stateFilter) {
      return '';
    }

    return STATE_CODE_TO_LABEL[stateFilter]?.toUpperCase() || '';
  }, [stateFilter]);

  return (
    <Dropdown title="State" filterCount={indicatorText}>
      <RadioButtons
        value={stateFilter || ''}
        onChange={handleStateChange}
        options={stateOptions}
      />
    </Dropdown>
  );
};

export default StateFilter;
